import React from 'react';
import ReactDOM from "react-dom/client";
import App from './App';
import * as serviceWorker from './serviceWorker';
import {UserProvider} from "./context/UserContext";
import {NotificationProvider} from "./context/NotificationContext";
import {MenuProvider} from "./context/MenuContext";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
    <UserProvider>
        <NotificationProvider>
            <MenuProvider>
                <App />
            </MenuProvider>
        </NotificationProvider>
    </UserProvider>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
